import { Typography } from "@aircall/tractor";
import { PropsWithChildren } from "react";

export function TranscriptionMessageTitle({
  children,
  "data-test": dataTest = "transcription-message-title",
}: PropsWithChildren<{
  "data-test"?: string;
}>) {
  return (
    <Typography variant="headingBoldM" textAlign="center" data-test={dataTest}>
      {children}
    </Typography>
  );
}
